import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProjectDeliveryDetail, getProjectManager, quotationAllocation } from '../../api';
export default {
  name: 'quotationAssignDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      quotationId: null,
      projectId: null,
      detailLoading: false,
      submitLoading: false,
      leaderOptions: [],
      assignForm: {
        customer_name: '',
        project_name: '',
        person_charge_id: null,
        remarks: ''
      },
      assignRules: {
        project_name: [{
          required: true,
          message: '请输入项目名称',
          trigger: 'blur'
        }],
        person_charge_id: [{
          required: true,
          message: '请选择负责人',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  methods: {
    open: function open(row) {
      var _this = this;
      this.quotationId = row.item_id;
      this.projectId = row.project_id;
      this.assignForm = {
        customer_name: '',
        project_name: '',
        person_charge_id: null,
        remarks: ''
      };
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs.assignForm && _this.$refs.assignForm.clearValidate();
      });
      if (!this.leaderOptions.length) {
        this.loadLeaderOptions();
      }
      this.loadDetail();
    },
    loadLeaderOptions: function loadLeaderOptions() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getProjectManager();
            case 1:
              res = _context.v;
              _this2.leaderOptions = res.data && res.data.list || [];
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    loadDetail: function loadDetail() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, detail, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _this3.detailLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return getProjectDeliveryDetail({
                id: _this3.projectId
              });
            case 2:
              res = _context2.v;
              detail = res.data || {};
              _this3.assignForm.customer_name = detail.customer_name || '';
              _this3.assignForm.project_name = detail.project_name || '';
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
            case 4:
              _context2.p = 4;
              _this3.detailLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }))();
    },
    handleDialogClose: function handleDialogClose(done) {
      done();
    },
    submitAssign: function submitAssign() {
      var _this4 = this;
      this.$refs.assignForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
          var _t2;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (valid) {
                  _context3.n = 1;
                  break;
                }
                return _context3.a(2);
              case 1:
                _this4.submitLoading = true;
                _context3.p = 2;
                _context3.n = 3;
                return quotationAllocation({
                  id: _this4.quotationId,
                  project_id: _this4.projectId,
                  project_name: _this4.assignForm.project_name,
                  person_charge_id: _this4.assignForm.person_charge_id,
                  remarks: _this4.assignForm.remarks
                });
              case 3:
                _this4.$message.success('分配成功');
                _this4.dialogVisible = false;
                _this4.$emit('success');
                _context3.n = 5;
                break;
              case 4:
                _context3.p = 4;
                _t2 = _context3.v;
              case 5:
                _context3.p = 5;
                _this4.submitLoading = false;
                return _context3.f(5);
              case 6:
                return _context3.a(2);
            }
          }, _callee3, null, [[2, 4, 5, 6]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};